import * as Yup from "yup";
import checkout from "./form038C";

const {
  formField038C: { totalTaxTNDN, totalExpense },
} = checkout;

const validation038C = Yup.object().shape({
  [totalTaxTNDN.name]: Yup.number().required(totalTaxTNDN.errorMsg),
  [totalExpense.name]: Yup.number().required(totalExpense.errorMsg),
});

export default validation038C;
